import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import "react-datepicker/dist/react-datepicker.css";
import { changeDateFormat} from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import messages from '../.././../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import  {generateWagesRateExcel}  from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import priceTitle from '../../../../price.json';

function WagesRatesReport() {
    // const token = useContext(MyContextProvider).token;
    // const decode_token = jwtDecode(token);
    const decode_token = getUserClaimsForUi();
    const token = decode_token
    const [years, setYears] = useState([]);
    const [yearName, setYearName] = useState("");
    const [reportName, setReportName] = useState("");
    const storedLanguage = localStorage.getItem('language');
    const navigate = useNavigate();
    // const config = {
    //     headers: {
    //         Authorization: `Bearer ${token}`,
    //     },
    // };
    const config = getAuthHeaders();


useEffect(() => {
    const getYearList = () => {
    setYears(getAllYears());
    };
    getYearList();
}, []);




    //get Years 
const getAllYears = () => {
    const currentYear = new Date().getFullYear();
    const yearsArray = [];
    for (let year = currentYear; year >= 2001; year--) {
        yearsArray.push(year);
    }
    return yearsArray;
};  

   
//get next Years 
const getNextYear = (year) => {
    const nextYear = parseInt(year) + 1;
    // const nextYearShort = nextYear.toString().slice(-2);
    const nextYearShort = nextYear.toString();
    return `${year} - ${nextYearShort}`;
};


    // Handle on change Event ********
 const handleDropdownChange = (e) => {
    
    switch (e.target.name) {
        case "yearName":
        setYearName(e.target.value);
        break;
        case "reportName":
        setReportName(e.target.value);
        break;
    default:
        break;
    }
 };



// Function to generate Excel file using mapped data
const handleGenerateExcel = async () => {
   
        if (!yearName) {
            toast.error("Please select a Survey Year", messages.COLOR_RED);
            return;
        }
        if (!reportName) {
            toast.error("Please select a Report Name", messages.COLOR_RED);
            return;
        }

try{

    let postData = {
        report: reportName,
        year:yearName
        }
    showLoading(true);
    const response = await axios.post(`${API_URL}api/price/ruralWagesRatesReport`, postData, config);
    const allData = response.data;
            downloadReport(allData.data.groupCodes,reportName,yearName)

  } catch (error) {
    console.error(error);
    toast.error('An error occurred while processing your request.', messages.COLOR_RED);
} finally {
  showLoading(false);
}
}

 



  // handle Download All report Data ****************
  const downloadReport=(allData,reportName,yearName)=>{
    let year=getNextYear(yearName);
  let reportData='';
    if(reportName==='agri'){
         reportData=allData.map(item => [
            item.districtnamehindi,
            item.PercentageWeight,
            item.JUL_G,
            item.AUG_G,
            item.SEP_G,
            item.OCT_G,
            item.NOV_G,
            item.DEC_G,
            item.JAN_G,
            ''
          ]);
    }else{
         reportData=allData.map(item => [
            item.districtnamehindi,
            item.PercentageWeight,
            item.JUL_G,
            item.AUG_G,
            item.SEP_G,
            item.OCT_G,
            item.NOV_G,
            item.DEC_G,
            item.JAN_G,
            item.FEB_G,
            item.MAR_G,
            item.APR_G,
            item.MAY_G,
            item.JUN_G,
            '',
            ''
          ]);
    }
  

      let headerEnglishColumns='';
      let number='';
      let headerFirstColumn='';
      let headerStateColumn='';
      let firstRowMergeCells='';
      let secondRowMergeCells=''
      let sheetName='';

       if(reportName==='barber' ||  
          reportName==='rmason' || 
         reportName==='uskill' || 
         reportName==='avgrmasonunskill'
    ){ //Barber

        headerEnglishColumns= [ 'जनपद', 'प्रतिशत', 'जुलाई','अगस्त','सितम्बर','अक्टूबर',
            'नवम्बर', 'दिसम्बर','जनवरी','फरवरी','मार्च',
            'अप्रैल', 'मई','जून','औसत कृषि वर्ष','']

            let mad='';


            if(reportName==='barber'){
                mad="नाई";
            }else if(reportName==='rmason'){
                mad="राज";
            }else if(reportName==='uskill'){
                mad="अकुशल  मजदूर";  
            }else if(reportName==='avgrmasonunskill'){
                mad="राज  व अ० श्रमिक का औसत ";  
            }
        headerFirstColumn=[`मद: ${mad}`,'','','','','','','रु0/ प्रति दिन','',
        '','','','','','','']
        headerStateColumn=['उत्तर प्रदेश','','','','','','','','','','','','','','','']
        number=[`1`,`2`,`3`,`4`, `5`,`6`,`7`,`8`,`9`,`10`,`11`,`12`,`13`,`14`,`15`,`16`];
        firstRowMergeCells="A1:P1";
        secondRowMergeCells="A2:P2"
        sheetName= 'pri_lws_wages_unskilled';
       }else if(reportName==='tailor'){ //Tailor

        headerEnglishColumns= [ 'जनपद', 'प्रतिशत', 'जुलाई','अगस्त','सितम्बर','अक्टूबर',
            'नवम्बर', 'दिसम्बर','जनवरी','फरवरी','मार्च',
            'अप्रैल', 'मई','जून','औसत कृषि वर्ष','']
    
       headerFirstColumn=[`मद: दर्जी`,'','','','','','','','',
        '','','','','','','']
        headerStateColumn=['उत्तर प्रदेश','','','','','','','','','','','','','','','']
        number=[`1`,`2`,`3`,`4`, `5`,`6`,`7`,`8`,`9`,`10`,`11`,`12`,`13`,`14`,`15`,`16`];
        firstRowMergeCells="A1:O1";
        secondRowMergeCells="A2:O2"
        sheetName= 'pri_lws_wages_unskilled';
       }else if(reportName==='agri'){
        headerEnglishColumns= [
            'जनपद', 'प्रतिशत', 'हल चलाना', 'बीज बोना', 'निरार्द गुड़ाई', 'फसल कटाई',
            'फसल दवाई', 'अन्य खेतिहर', 'औसत कृषि वर्ष','' ]
        headerFirstColumn=[`मद: कृषि मजदूर`,'','','','','','','','','' ]
        headerStateColumn=['उत्तर प्रदेश','','','','','','','','','']
        number=[`1`,`2`,`3`,`4`, `5`,`6`,`7`,`8`,`9`,`10`];
        firstRowMergeCells="A1:J1";
        secondRowMergeCells="A2:J2"
        sheetName= 'pri_lws_wages_agri_labor';
       }

  let reportStructure = {
    number:number,
    year:yearName,
    state:"उत्तर प्रदेश",
    reportType:reportName,
    fileName:`PriLwsRuralWagesRate_${yearName}`,
    fileType:'xls',
    sheetName: sheetName,
    firstRowMergeCells: firstRowMergeCells,
    firstRowExportDate:  changeDateFormat(new Date()),
    secondRowMergeCells: secondRowMergeCells,
    secondRowText: `कृषि क्रय  विक्रय समता सूचकांक हेतु कुछ चुने हुए जिलों से ग्रामीण फुटकर भाव - ग्रामीण मजदूरी दरें ${year}`,
    headerStateColumn:headerStateColumn,
    headerFirstColumn: headerFirstColumn,
    headerEnglishColumns: headerEnglishColumns ,
    excelRowData:reportData
}

   generateWagesRateExcel(reportStructure)
 }

  return (
    <>
    <ToastContainer />
    <GlobalLoading />
    <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
            <div className="card-body pb-1">
                <div className="row align-items-center">
                    <h4 className="page_heading">
                     <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.WAGES_RATES_REPORT : priceTitle.en.WAGES_RATES_REPORT }} />
              
                    </h4>
                    <div className="row align-items-center">
                        

                        <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                            <label className="fw-bold h6">Select Agriculture Year</label>
                            <select
                            name="yearName"
                            className="form-select"
                            onChange={handleDropdownChange}
                            value={yearName}
                            >
                            <option value="" disabled>Select Month</option>
                                 {years &&
                                  years.map((ele, index) => (
                                 <option key={index} value={ele}>
                                    {getNextYear(ele)}
                                 </option>
                                 ))}
                         </select>
                        </div>


                        <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                            <label className="fw-bold h6">Select Report</label>
                            <select
                            name="reportName"
                            className="form-select"
                            onChange={handleDropdownChange}
                            value={reportName}
                            >
                            <option value="" disabled>Select Year</option>
                            <option value="barber">Barber</option>
                            <option value="tailor">Tailor</option>
                            <option value="agri">Agri.Labour</option>
                            <option value="rmason">Rural Wages Mason</option>
                            <option value="uskill">Urban Unskilled Labour</option>
                            <option value="avgrmasonunskill">Avg of Mason &amp; Unskilled Laour</option>
              
                          </select>
                        </div>


                        <div className="col-xl-2 col-lg-4 mb-3">
                            <label className="w-100 d-none d-sm-block">&nbsp;</label>
                            <button onClick={handleGenerateExcel} className="btn btn_orange">Search</button>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
   </>
  )
}

export default WagesRatesReport